export default "__VITE_ASSET__BDZOb3Mc__"